import { __assign, __rest } from "tslib";
// DS: C16A
// DS: CR52
/** Displays a whole thread of comments and post box */
import React from 'react';
import OffsetTrackingCommentThread from './presets/OffsetTrackingCommentThread';
import SimpleThread from './presets/SimpleThread';
import ModalThread from './presets/ModalThread';
import CardLayoutThread from './presets/CardLayoutThread';
// this component is now just a shell for existing usages - if adding a new
// thread, go directly for one of the presets instead
var CommentThread = function (_a) {
    var enableOffsetTracking = _a.enableOffsetTracking, isModal = _a.isModal, useCardLayout = _a.useCardLayout, props = __rest(_a, ["enableOffsetTracking", "isModal", "useCardLayout"]);
    if (isModal) {
        return React.createElement(ModalThread, __assign({}, props));
    }
    if (useCardLayout) {
        return React.createElement(CardLayoutThread, __assign({}, props));
    }
    if (enableOffsetTracking) {
        return React.createElement(OffsetTrackingCommentThread, __assign({}, props));
    }
    return React.createElement(SimpleThread, __assign({}, props));
};
CommentThread.displayName = 'CommentThread';
export default CommentThread;
//# sourceMappingURL=CommentThread.js.map